// epic.js
import 'rxjs'
import { combineEpics } from 'redux-observable'
import HeaderEpic$ from './header.epic'
import AuthEpic$ from './auth.epic'
import AppEpic$ from './app.epic'
import ReportEpic$ from './report.epic'
import PatientEpic$ from './patient.epic'
import InquiryEpic$ from './inquiry.epic'

const epics = combineEpics(
  ...HeaderEpic$,
  ...AuthEpic$,
  ...AppEpic$,
  ...ReportEpic$,
  ...PatientEpic$,
  ...InquiryEpic$
)

export default epics



// WEBPACK FOOTER //
// ./src/epics/index.ts